import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { goldCoin, load, ticket } from './svg';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Modal from '../../Components/Organisms/Modal';
import useData from './data';
import SkeletonMyRewardPoints from '../../Components/Molecules/Skeleton/SkeletonMyRewardPoints';


const MyRewardPoints = () => {
    const history = useHistory();
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const [showTooltip, setShowTooltip] = useState();
    const { loading, pointActivitiesList, setLoadMore, totalPages } = useData();
    console.log("pointActivitiesList", pointActivitiesList);

    return (
        <div>
            {isAuthenticated && (
                <div className="w-full md:pl-3 lg:pl-7 2xl:pl-7 ">
                    <div className="mb-4 ml-2">
                        <h1 className=" font-Poppins text-xl md:text-2xl font-bold ">
                            Reward Points
                        </h1>
                    </div>
                    <div className="flex flex-row gap-4 mb-8">
                        <img
                            src="https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1740136221694_card"
                            className="w-full lg:w-auto lg:flex-[1] 2xl:flex-[1.5]"
                        />
                        <img
                            src="https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1740135547214_rewardPointBanner"
                            className="lg:flex-[4] 2xl:flex-[3.5] hidden lg:block object-contain"
                        />
                    </div>
                    <div className="mb-4 mt-2">
                        <h2 className="text-[18px] font-bold">
                            Point Activities
                        </h2>
                        <p className="text-[#130E2F] text-[16px] font-Roboto">
                            All about your logs
                        </p>
                    </div>

                    {loading && (
                        <>
                            <div className="mb-6">
                                {[...Array(1).keys()].map((n) => (
                                    <SkeletonMyRewardPoints key={n} />
                                ))}
                            </div>
                            <div className="mt-6 mb-6">
                                {[...Array(1).keys()].map((n) => (
                                    <SkeletonMyRewardPoints key={n} />
                                ))}
                            </div>
                        </>
                    )}

                    <div className="bg-white rounded-lg py-1 relative z-10">
                        {pointActivitiesList.map((item, index) => {

                            const dateObj = new Date(item.updatedOn);
                            const formattedDate = dateObj.toLocaleString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                            }).replace(",", " |");
                            const isEarn = item.type === "EARN";

                            return (
                                <div
                                    key={index}
                                    className="flex justify-between items-center p-4 border border-[#E8E8E8] mb-3 relative"
                                >
                                    <div>
                                        <p className="font-medium text-[#1A1A1A] font-Roboto">{item.type}</p>
                                        <p className="text-[13px] text-[#1A1A1A] font-Roboto">{formattedDate}</p>
                                    </div>
                                    <div className="flex items-center gap-4">
                                        <div className="flex flex-col items-end">
                                            <span className={isEarn ? 'text-green-500 font-bold' : 'text-red-500 font-bold'}>
                                                {isEarn ? '+' : '-'}{item.points}
                                            </span>
                                        </div>
                                        <div className="relative inline-block z-50"
                                            onClick={() => history.push("/contact-us")}>
                                            <div
                                                className="p-2 cursor-pointer"
                                                onMouseEnter={() => setShowTooltip(index)}
                                                onMouseLeave={() => setShowTooltip(null)}
                                            >
                                                {ticket}
                                            </div>
                                            {showTooltip === index && (
                                                <div
                                                    className="absolute top-full mt-2 left-[3px] transform -translate-x-1/2 bg-primary text-white text-xs font-medium rounded-md px-3 py-2 shadow-lg whitespace-nowrap z-50 cursor-pointer"
                                                    onClick={() => history.push("/contact-us")}
                                                >
                                                    Create Ticket
                                                    <div className="absolute right-1/4 bottom-full -translate-x-1/2 w-0 h-0 border-b-8 border-b-primary border-l-4 border-l-transparent border-r-4 border-r-transparent"></div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    {totalPages > 1 && (
                        <button

                            onClick={() =>
                                setLoadMore((prev) => prev + 8)
                            }
                            className="flex items-center justify-center gap-x-2 mx-auto w-[111px] h-[40px]  border-[3px] border-[#DDDDDD] rounded mt-6 "
                        >
                            <span className="text-[#908F95] text-sm font-medium font-Roboto">
                                {' '}
                                Load more
                            </span>

                            {load}
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default MyRewardPoints;
